// TODO: Overlay handling will be reworked anyway
import { OverlayPayloadRegistry } from "./registry"

export enum OverlayStyle {
  CONTENT = "CONTENT",
  ACTIONS = "ACTIONS",
  CONFIRMATION = "CONFIRMATION",
  FORM = "FORM",
  SEARCH = "SEARCH"
}

export const CONTENT_OVERLAY = "CONTENT_OVERLAY" as const
export const NEW_PROJECT_OVERLAY = "NEW_PROJECT_OVERLAY" as const
export const EDIT_PROJECT_OVERLAY = "EDIT_PROJECT_OVERLAY" as const
export const PROJECT_ACTIONS_OVERLAY = "PROJECT_ACTIONS_OVERLAY" as const
export const DELETE_PROJECT_OVERLAY = "DELETE_PROJECT_OVERLAY" as const
export const DUPLICATE_PROJECT_OVERLAY = "DUPLICATE_PROJECT_OVERLAY" as const
export const FEEDBACK_ACTIONS_OVERLAY = "FEEDBACK_ACTIONS_OVERLAY" as const
export const PROJECT_GAEB_OVERLAY = "PROJECT_GAEB_OVERLAY" as const
export const PROJECT_PDF_OVERLAY = "PROJECT_PDF_OVERLAY" as const
export const MUSTERHEFT_EXPORT_OVERLAY = "MUSTERHEFT_EXPORT_OVERLAY" as const
export const PROJECT_ATTACHMENTS_OVERLAY =
  "PROJECT_ATTACHMENTS_OVERLAY" as const
export const SHARED_PROJECT_ACTIONS_OVERLAY =
  "SHARED_PROJECT_ACTIONS_OVERLAY" as const
export const LOGIN_OVERLAY = "LOGIN_OVERLAY" as const

export const DELETE_ADDON_OVERLAY = "DELETE_ADDON_OVERLAY" as const
export const SELECT_PRODUCT_CONFIGURATION_PRESET_OVERLAY =
  "SELECT_PRODUCT_CONFIGURATION_PRESET_OVERLAY" as const

export const NEW_ROOM_OVERLAY = "NEW_ROOM_OVERLAY" as const
export const EDIT_ROOM_OVERLAY = "EDIT_ROOM_OVERLAY" as const
export const COPY_ROOM_OVERLAY = "COPY_ROOM_OVERLAY" as const
export const ROOM_ACTIONS_OVERLAY = "ROOM_ACTIONS_OVERLAY" as const
export const DELETE_ROOM_OVERLAY = "DELETE_ROOM_OVERLAY" as const

export const NEW_FLOOR_OVERLAY = "NEW_FLOOR_OVERLAY" as const
export const EDIT_FLOOR_OVERLAY = "EDIT_FLOOR_OVERLAY" as const
export const COPY_FLOOR_OVERLAY = "COPY_FLOOR_OVERLAY" as const
export const DELETE_FLOOR_OVERLAY = "DELETE_FLOOR_OVERLAY" as const
export const FLOOR_ACTIONS_OVERLAY = "FLOOR_ACTIONS_OVERLAY" as const

export const NEW_PRODUCT_POSITION_OVERLAY =
  "NEW_PRODUCT_POSITION_OVERLAY" as const
export const EDIT_PRODUCT_POSITION_OVERLAY =
  "EDIT_PRODUCT_POSITION_OVERLAY" as const
export const PRODUCT_POSITION_ACTIONS_OVERLAY =
  "PRODUCT_POSITION_ACTIONS_OVERLAY" as const
export const DELETE_PRODUCT_POSITIONS_OVERLAY =
  "DELETE_PRODUCT_POSITIONS_OVERLAY" as const

export const COPY_PROJECT_CHILDREN_OVERLAY =
  "COPY_PROJECT_CHILDREN_OVERLAY" as const
export const DELETE_PROJECT_CHILDREN_OVERLAY =
  "DELETE_PROJECT_CHILDREN_OVERLAY" as const

export const FAVORITE_ACTIONS_OVERLAY = "FAVORITE_ACTIONS_OVERLAY" as const
export const DELETE_FAVORITES_OVERLAY = "DELETE_FAVORITES_OVERLAY" as const

export const GLOBAL_SEARCH_OVERLAY = "GLOBAL_SEARCH_OVERLAY" as const

export const PORTFOLIO_PRODUCT_SELECT_OVERLAY =
  "PORTFOLIO_PRODUCT_SELECT_OVERLAY" as const

export const PRODUCT_CONFIGURATOR_MODE_SELECT_OVERLAY =
  "PRODUCT_CONFIGURATOR_MODE_SELECT_OVERLAY" as const
export const PRODUCT_CONFIGURATION_OVERLAY =
  "PRODUCT_CONFIGURATION_OVERLAY" as const

export const FEEDBACK_OVERLAY = "FEEDBACK_OVERLAY" as const
export const SHARE_OVERLAY = "SHARE_OVERLAY" as const
export const LOGOUT_OVERLAY = "LOGOUT_OVERLAY" as const

export const INSTALLATION_REFERENCE_SELECTION_OVERLAY =
  "INSTALLATION_REFERENCE_SELECTION_OVERLAY" as const

export const DEMAND_REQUEST_OVERLAY = "DEMAND_REQUEST_OVERLAY" as const

export const CONFIRMATION_OVERLAY = "CONFIRMATION_OVERLAY" as const

export const PORTAL_NEWS_OVERLAY = "PORTAL_NEWS_OVERLAY" as const

export const ADD_TEAM_MEMBERS_OVERLAY = "ADD_TEAM_MEMBERS_OVERLAY" as const
export const MANAGE_PROJECT_TEAM_OVERLAY =
  "MANAGE_PROJECT_TEAM_OVERLAY" as const
export const PROJECT_TEAM_INVITATION_LIST_OVERLAY =
  "PROJECT_TEAM_INVITATION_LIST_OVERLAY" as const
export const TEAM_LEAVE_OVERLAY = "TEAM_LEAVE_OVERLAY" as const

export const PROFILE_DELETE_REQUEST_CODE_OVERLAY =
  "PROFILE_DELETE_REQUEST_CODE_OVERLAY" as const
export const PROFILE_DELETE_CODE_OVERLAY =
  "PROFILE_DELETE_CODE_OVERLAY" as const

export const IMAGE_OVERLAY = "IMAGE_OVERLAY" as const
export const PRODUCT_IMAGE_OVERLAY = "PRODUCT_IMAGE_OVERLAY" as const

export const PROJECT_HISTORY_OVERLAY = "PROJECT_HISTORY_OVERLAY" as const

export const DELETE_ATTACHMENT_OVERLAY = "DELETE_ATTACHMENT_OVERLAY" as const
export const REPLACE_ATTACHMENT_OVERLAY = "REPLACE_ATTACHMENT_OVERLAY" as const

export type OverlayType = keyof OverlayPayloadRegistry

/**
 * Represents the options for an overlay.
 */
export interface OverlayOptions {
  id?: string
  // The ID of the element to focus when the overlay is closed.
  focusElementID?: string
  onClose?: () => void
}

export interface GenericOverlay<T extends OverlayType> {
  id: string
  type: T
  payload: OverlayPayloadByOverlayType<T>
  options?: OverlayOptions
}

type OverlayUnion<O extends OverlayType> = O extends OverlayType
  ? GenericOverlay<O>
  : never

export type Overlay = OverlayUnion<OverlayType>

export type OverlayPayloadByOverlayType<T extends OverlayType> =
  OverlayPayloadRegistry[T]

export interface OverlayReducerState {
  overlays: Overlay[]
}
